// GENERATED by scripts/build-icons.mjs from icons/map-pin.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const MapPin = createIcon('map-pin', [
  ['path', { d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" }],
  ['circle', { cx: "12", cy: "10", r: "3" }],
])
